import ReportedUserModal from './ReportedUserModal';

export default ReportedUserModal;
